<template>
  <div class="row">
    <div class="col-lg-3">
      <div class="card">
        <div class="card-body">
          <div class="nav flex-column nav-pills">
            <router-link exact class="nav-link" to="/trials/create">General</router-link>
            <router-link exact class="nav-link" to="/trials/create/2"
              :class="{disabled: !$store.getters.firstStepIsValid}"
              :event="$store.getters.firstStepIsValid ? 'click' : ''"
              disabled
            >Key Account</router-link>
            <router-link exact class="nav-link" to="/trials/create/3"
              :class="{disabled: !$store.getters.firstStepIsValid}"
              :event="$store.getters.firstStepIsValid ? 'click' : ''"
              disabled
            >Equipment and Printers</router-link>
            <router-link exact class="nav-link" to="/trials/create/4"
              :class="{disabled: !$store.getters.firstStepIsValid}"
              :event="$store.getters.firstStepIsValid ? 'click' : ''"
              disabled
            >Products</router-link>
            <router-link exact class="nav-link" to="/trials/create/5"
              :class="{disabled: !$store.getters.firstStepIsValid}"
              :event="$store.getters.firstStepIsValid ? 'click' : ''"
              disabled
            >Communication</router-link>
            <router-link exact class="nav-link" to="/trials/create/6"
              :class="{disabled: !$store.getters.firstStepIsValid}"
              :event="$store.getters.firstStepIsValid ? 'click' : ''"
              disabled
            >Promotion</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-9">
      <div class="tab-content">
        <div class="card">
          <div class="card-body">
            <router-view />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    created() {
      this.$store.dispatch('fetchSmallProducts');
      this.$store.dispatch('fetchMiddleProducts');
      this.$store.dispatch('fetchLargeProducts');
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/trials/CreateTrial.vue